import {
    addVal,
    getCart,
    getProperMinOrderQty,
    minStep,
    removeVal,
    fetchProductSuggestions,
    showOutOfStockModal,
    showLimitedStockModal,
    setControlsColorFunctionality, updateUnitPrices
} from "./cart-helpers.js";
import {sendGetPromise, sendPostPromise, sendPutPromise} from "../../helpers/sendAjax.js";

export default function () {
    let _state = {
        potentialOrderPromotions: 0,
        potentialProductPromotions: 0,
        entries: 0
    };

    let requestFinished = true;

    const setFunctionalityOnControls = (controls) => {
        controls.forEach(control => {
            const id = control.dataset.id;
            const qtyInput = control.querySelectorAll(`.js-product-qty-${id}`)[0];
            const buttonPlus = control.querySelectorAll(`.js-product-controls-up-${id}`)[0];
            const buttonMinus = control.querySelectorAll(`.js-product-controls-down-${id}`)[0];
            const unitInput = control.querySelectorAll(`.js-product-unit-${id}`)[0];

            setAgreementForProduct(id);

            const minOrderQtyInput = control.querySelectorAll(`.min-order-qty-${id}`)[0];
            const minOrderQty = !!minOrderQtyInput ? Math.round(parseFloat(minOrderQtyInput.value)) : 1;

            unitInput.addEventListener('change', (e) => {
                if (qtyInput.value.length <= 0 || qtyInput.value <= 0) {
                    qtyInput.value = 0;
                    return;
                }

                $(unitInput).val(e.target.value);
                updateQuantity(control, qtyInput.value, id, e.target.value);
            });

            buttonPlus.addEventListener('click', () => {
                const unit = unitInput.value;
                updateQuantity(control, addVal(qtyInput.value, getProperMinOrderQty(unit, minOrderQty)), id, unit);
            });

            buttonMinus.addEventListener('click', () => {
                const unit = unitInput.value;
                const prodQty = removeVal(qtyInput.value, getProperMinOrderQty(unit, minOrderQty));
                if (prodQty <= 0) {
                    openRemoveProductPopup(id, qtyInput);
                    return;
                }
                updateQuantity(control, prodQty, id, unit);
            });


            qtyInput.addEventListener('blur', () => {
                const unit = unitInput.value;

                if (qtyInput.value.length <= 0) {
                    qtyInput.value = 0;
                }

                qtyInput.value = minStep(qtyInput.value, getProperMinOrderQty(unit, minOrderQty));

                if (qtyInput.value <= 0) {
                    openRemoveProductPopup(id, qtyInput);
                    return;
                }

                updateQuantity(qtyInput, qtyInput.value, id, unit);
            });

            qtyInput.addEventListener('keypress', (e) => {
                if (e.which == 13) {
                    qtyInput.blur();
                    return false;
                }

                return true;
            });

            qtyInput.addEventListener("input", function (evt) {
                qtyInput.value = qtyInput.value.replace(/\D/g, "");

                if ((evt.which < 48 || evt.which > 57)) {
                    evt.preventDefault();
                }
            });
        })
    };

    const getCartEntry = (cartData, productCode) => {
        return !cartData || !productCode ? null : cartData.entries.find(entry => entry.product.code === productCode);
    };
    const updateQuantity = (elementQuantity, qty, id, unit) => {
        let existEntry;
        const wrapQuantity = $(elementQuantity).closest('.js-minicart-quantity');
        const uniqueProduct = $(wrapQuantity).data('unprod');
        const data = `qty=${qty}&productCodePost=${id}&unitCode=${unit}`;

        const processCartUpdates = (jsonData, existEntry) => {
            if (jsonData?.entries?.length > 0) {
                updateMinicartHtml(jsonData).then(() => {
                    updateEntryListHtml(jsonData, id, uniqueProduct, wrapQuantity);

                    setCartDataFromJson(jsonData, {id, unit})

                    setAgreementForProduct(id);
                })
            } else {
                $(".minicart__empty").removeClass("hidden");
                $(".minicart__filled").addClass("hidden");
                $(".js-mini-cart-count").css({display: 'none'});
                $(".js-mini-cart-link > div.price").text('0,00 Kr');
                document.querySelectorAll('.js-product-controls input[name=quantity]').forEach(i => {
                    i.setAttribute('value', '0');
                    i.value = 0;
                });

                updateProductAllControls(id, 0);
            }

            updateFreeDelivery(jsonData);
            updateAnalytics(getCartEntry(jsonData, id), existEntry);
        };

        if (!requestFinished) {
            return;
        }

        requestFinished = false;

        getCart()
            .then(cartBeforeUpdate => {
                existEntry = getCartEntry(cartBeforeUpdate, id);

                return sendPutPromise(`/dafgards/cart/update?${data}`, {})
            })
            .then(() => getCart())
            .then(jsonData => {
                processCartUpdates(jsonData, existEntry);
                requestFinished = true;
            })
            .catch(e => {
                if (e.status === 409) {
                    if(e.responseJSON.statusCode === 'noStock') {
                        fetchProductSuggestions(id, qty, unit, showOutOfStockModal);
                    } else if(e.responseJSON.statusCode === 'maxOrderQuantityExceeded') {
                        getCart().then(e => processCartUpdates(e, existEntry));
                        fetchProductSuggestions(id, e.responseJSON.quantity, unit, showLimitedStockModal);
                    }
                    requestFinished = true;
                }
            });
    };

    const updateMinicartHtml = (cartData) => {
        if (!(hasStateChanged(cartData))) {
            const potentialOrderPromoMessages = document.querySelectorAll('.js-minicart-promotions')[0];

            if (potentialOrderPromoMessages) {
                potentialOrderPromoMessages.innerHTML = cartData.potentialOrderPromotions.reduce((acc, promotion) => {
                    return acc + `<div class="message">${promotion.description}</div>`
                }, '');
            }

            return Promise.resolve();
        }

        const {
            potentialOrderPromotions,
            entries
        } = cartData;

        return sendGetPromise(`${window.origin}/cart/rollover`).then(htmlData => {
            const html = document.createElement('div');
            html.innerHTML = htmlData;

            if (potentialOrderPromotions.length !== _state.potentialOrderPromotions) {
                const potentialOrderPromo = document.querySelectorAll('.js-potential-order-promotions')[0];
                const newPotentialOrderPromo = html.querySelectorAll('.js-potential-order-promotions')[0];

                potentialOrderPromo.replaceWith(newPotentialOrderPromo);
            }

            const minicartList = document.querySelectorAll('.js-minicart-list')[0];
            const newMinicartList = html.querySelectorAll('.js-minicart-list')[0];

            minicartList.replaceWith(newMinicartList);
            const controls = document.querySelectorAll('.js-minicart-list .js-product-controls');
            setFunctionalityOnControls(controls);
            entries.forEach(entry => updateEntryHtmlPrices(entry));
            setPromotionsState(cartData);
        });
    }

    const updateFreeDelivery = (jsonData) => {
        if(jsonData.freeDeliveryAmount !== null) {
            let freeDeliveryBlock = $(".minicart__free-delivery");
            if(freeDeliveryBlock.length > 0) {
                if(jsonData.freeDeliveryAmount > 0) {
                    $('.minicart__free-delivery .minicart__free-delivery-not-available').removeClass("hidden");
                    $('.minicart__free-delivery .minicart__free-delivery-available').addClass("hidden");
                    $('.minicart__free-delivery .minicart__free-delivery-not-available .free-delivery-amount').html(jsonData.freeDeliveryAmount);
                    if(jsonData.freeDeliveryAmount > 1) {
                        $('.minicart__free-delivery .free-delivery-unit-single').addClass("hidden");
                        $('.minicart__free-delivery .free-delivery-unit-multiple').removeClass("hidden");
                    } else {
                        $('.minicart__free-delivery .free-delivery-unit-single').removeClass("hidden");
                        $('.minicart__free-delivery .free-delivery-unit-multiple').addClass("hidden");
                    }
                } else {
                    $('.minicart__free-delivery .minicart__free-delivery-not-available').addClass("hidden");
                    $('.minicart__free-delivery .minicart__free-delivery-available').removeClass("hidden");
                }
            }
        }
    }

    const updateAnalytics = (updatedEntry, existEntry) => {
        // update analytics dataLayer
        const initialItemsQty = existEntry ? existEntry.quantity : 0;
        if (updatedEntry && initialItemsQty < updatedEntry.quantity) {
            ACC.gtm.addToCart_gtm(updatedEntry.product.code, updatedEntry.product.name,
                updatedEntry.basePrice.value, updatedEntry.quantity - initialItemsQty);
        }

        if (!updatedEntry && existEntry && initialItemsQty > 0) {
            ACC.gtm.removeFromCart_gtm(existEntry.product.code, existEntry.product.name,
                existEntry.basePrice.value, initialItemsQty);
        }

        if (updatedEntry && initialItemsQty > updatedEntry.quantity) {
            ACC.gtm.removeFromCart_gtm(updatedEntry.product.code, updatedEntry.product.name,
                updatedEntry.basePrice.value, initialItemsQty - updatedEntry.quantity);
        }
    }

    const removeAll = (miniCartCleanAllUrl) => {
        sendPostPromise(miniCartCleanAllUrl, {})
            .then(() => {
                $(".minicart__empty").removeClass("hidden");
                $(".minicart__filled").addClass("hidden");
                $(".js-mini-cart-link > div.price").text('0,00 Kr');
                $(".js-mini-cart-count").css({display: 'none'});
                document.querySelectorAll('.js-product-controls input[name=quantity]').forEach(i => {
                    i.setAttribute('value', '0');

                    i.value = 0;
                });
            })
            .catch(console.error)
    };

    const updateEntryListHtml = (jsonData, entryId, uniqueProduct, wrapQuantity) => {
        const entry = jsonData.entries.find(e => (!!e.product ? (e.product.code - 0) === (entryId - 0) : false));

        jsonData.entries.forEach(cartEntry => updateEntryHtmlPrices(cartEntry))

        if (!!entry) {
            updateUnitPrices(uniqueProduct, entry.unit.toLowerCase());
            $(wrapQuantity).find('input[name=initialQuantity]').val(entry.quantity);
        }

        updateProductAllControls(entryId, entry?.quantity ?? 0);
    };

    const updateEntryHtmlPrices = (entry) => {
        const unitPrice = document.querySelectorAll(`.js-entry-unit-price-${entry.product.code}`)[0];
        const comparisonPrice = document.querySelectorAll(`.js-entry-comparison-price-${entry.product.code}`)[0];

        if (unitPrice) {
            unitPrice.innerHTML = updateUnitPriceHtml(entry);
        }

        if (comparisonPrice) {
            comparisonPrice.innerHTML = updateComparisonPriceHtml(entry);
        }
    }

    const updateUnitPriceHtml = entry => {
        if (!!entry.promotionPrice) {
            return `
                    <span>
                        <del> ${entry.basePrice.formattedValue.split(' ')[0]} </del>
                    </span>
                    <span>
                        <span class="text-danger"> ${entry.promotionPrice.formattedValue.split(' ')[0]} </span>
                        kr/${entry.unit.toLowerCase()}
                    </span>
                `;
        } else {
            return `
                    <span>
                        <span> ${entry.basePrice.formattedValue.split(' ')[0]} </span>
                        kr/${entry.unit.toLowerCase()}
                    </span>
                `;
        }
    };

    const updateComparisonPriceHtml = entry => {
        if (!!entry.promotionPrice) {
            return `
                    <h4 class="promotion-price">
                            <span>
                                <span class="block">Jmf-pris</span>
                                <strong>
                                    <del>
                                        ${entry.basePrice.comparisonPrice ?? ''}
                                    </del>
                                </strong>
                            </span>
                            <span>
                                <strong class="text-danger">
                                    ${entry.promotionPrice.comparisonPrice ?? ''}
                                </strong>
                                ${entry.product.baseUnit?.toLowerCase() === 'st' ? 'kr/st' : 'kr/kg'}
                            </span>
                        </h4>
                `;
        } else {
            return `
                    <h4 class="base-price">
                        <span class="block">Jmf-pris</span>
                        <strong>
                            ${entry.basePrice.comparisonPrice ?? ''}
                        </strong>
                        ${entry.product.baseUnit?.toLowerCase() === 'st' ? 'kr/st' : 'kr/kg'}
                    </h4>
                `;
        }
    };

    const updateProductAllControls = (id, value) => {
        const qtyInputs = document.querySelectorAll(`.js-product-qty-${id}`);

        qtyInputs.forEach(input => {
            input.value = value;
            input.setAttribute('value', value);
        });
    };

    const openRemoveProductPopup = (id, qtyInput) => {
        const removeBtn = document.querySelector("#remove-mini-product");
        removeBtn.dataset.controlId = id;
        removeBtn.dataset.prodQty = qtyInput.value;
        removeBtn.dataset.initialQty = $(`.js-mini-product-${id}`).find("input[name='initialQuantity']").val();

        $('#removeMiniEntryModal').modal();
    };

    const setAgreementForProduct = (id) => {
        const agreementData = document.querySelectorAll(`.js-product-agreement-${id}`)[0];
        const tender = document.querySelectorAll(`.js-agreement-${id}`);

        if (!!agreementData && !!agreementData.dataset) {
            const agreement = agreementData.dataset.agreement;

            tender.forEach(t => {
                t.style.display = agreement === 'true' ? 'inline-block' : 'none';
            });
        }

    };

    const setCartDataFromJson = (jsonData, options) => {
        document.querySelectorAll('.js-minicart-discount-info').forEach(
            el => el.style.display = !!jsonData.totalDiscounts?.value > 0 ? 'inline-block' : 'none'
        );

        if (!!jsonData.subTotal) {
            $(".minicart__subtotal").html(jsonData.subTotal.formattedValue);
        }

        if (!!jsonData.totalTax) {
            $(".minicart__total-tax").html(jsonData.totalTax.formattedValue);
        }

        if (!!jsonData.totalDiscounts) {
            $(".minicart__discount").html(`-${jsonData.totalDiscounts.formattedValue}`);
        }

        if (!!jsonData.deliveryCost) {
            $(".minicart__delivery-cost").html(jsonData.deliveryCost.formattedValue);
        }

        if (!!jsonData.totalPriceWithTax) {
            $(".minicart__total-price").html(jsonData.totalPriceWithTax.formattedValue);
            $(".js-mini-cart-link > div.price").text(jsonData.totalPriceWithTax.formattedValue);
        } else if (!!jsonData.totalPrice) {
            $(".minicart__total-price").html(jsonData.totalPrice.formattedValue);
            $(".js-mini-cart-link > div.price").text(jsonData.totalPrice.formattedValue);
        }

        if (!!jsonData.totalUnitCount) {
            $(".js-mini-cart-link > div.mini-cart-count > span").text(jsonData.totalUnitCount);
        }

        const unitPrices = document.querySelectorAll(`.js-price-product-${options.id}-${options.unit.toLowerCase()}`);
        unitPrices.forEach(unitPrice => {
            const volPrice = unitPrice.parentNode.querySelectorAll('.vol-price-products');
            volPrice.forEach(vol => {
                vol.classList.add("hidden");
                const el = vol.querySelectorAll(`.js-product-agreement-${options.id}`)[0];
                if (!!el) {
                    el.classList.add("hidden")
                }
            });
            unitPrice.classList.remove("hidden");
            const unitEl = unitPrice.querySelectorAll(`.js-product-agreement-${options.id}`)[0];
            if (!!unitEl) {
                unitEl.classList.remove("hidden")
            }
        });
    };

    const setPromotionsState = (cartData) => {
        const {
            potentialOrderPromotions,
            potentialProductPromotions,
            entries
        } = cartData;

        _state = {
            potentialOrderPromotions: potentialOrderPromotions.length,
            potentialProductPromotions: potentialProductPromotions.length,
            entries: entries.length,
        }
    };

    const hasStateChanged = (cartData) => {
        const {
            potentialOrderPromotions,
            potentialProductPromotions,
            entries
        } = cartData;

        return _state.potentialOrderPromotions !== potentialOrderPromotions.length
            || _state.potentialProductPromotions !== potentialProductPromotions.length
            || _state.entries !== entries.length;
    }

    $(document).on("click", ".js-mini-cart-link", function (e) {
        e.preventDefault();
        const url = $(this).data("miniCartUrl");
        const cartName = ($(this).find(".js-mini-cart-count").html() != 0) ? $(this).data("miniCartName") : $(this).data("miniCartEmptyName");

        const colorboxConfig = {
            href: url,
            fixed: true,
            reposition: false,
            width: '100%',
            height: '100%',
            maxWidth: '618px',
            maxHeight: '100%',
            top: "0",
            right: "0",
            left: "auto",
            bottom: "0",
            className: "colorbox-mini-cart",
            close: '<span class="close-cross"></span>',
            onOpen: function () {
                $("html").addClass("html-overflow");
            },
            onClosed: function () {
                $("html").removeClass("html-overflow");
                ACC.common.refreshScreenReaderBuffer();
            }
        };

        ACC.colorbox.open(cartName, {
            ...colorboxConfig, onComplete: () => {
                const controls = document.querySelectorAll('.js-mini-cart .js-product-controls');
                const minicartCarousel = document.querySelectorAll('.carousel__component--block');

                if (minicartCarousel.length) {
                    ACC.carousel.bindColorboxCarousel($('.colorbox-mini-cart'));
                }

                setFunctionalityOnControls(controls);
                setControlsColorFunctionality(controls);

                getCart().then((cartData) => {
                    cartData.entries.forEach(entry => {
                        updateEntryHtmlPrices(entry);
                    });
                    setPromotionsState(cartData);
                })
            }
        });
    });

    $(window).resize(function () {
        ACC.colorbox.close();
    });

    $(document).on("click", ".js-mini-cart-close-button", function (e) {
        e.preventDefault();
        ACC.colorbox.close();
    });

    $(document).on("click", ".btn-clear", function (e) {
        e.preventDefault();
        removeAll($(e.target).data("url"));
    });

    //button in modal popup
    $(document).on("click", "#remove-mini-product", function (e) {
        const removeBtn = $(e.target);

        if (!!removeBtn.length) {
            const id = removeBtn[0].dataset.controlId;
            const control = $(`.js-mini-cart .js-product-controls[data-id=${id}]`);
            const unitInput = document.querySelectorAll(`.js-product-unit-${id}`)[0];
            updateQuantity(control, 0, id, unitInput.value);
        }

        $('#removeMiniEntryModal').modal('hide');
    });
}
